import { type FormEvent, useState } from 'react';
import { Button, Field, Input, Modal } from '../design';
import { useAuth } from './AuthProvider';

/** Cere codul TOTP proaspăt pentru acțiunile sensibile (publicare, deschidere administrativă, reset 2FA…). */
export function StepUpDialog() {
  const { stepUpRequest } = useAuth();
  const [code, setCode] = useState('');
  if (!stepUpRequest) return null;
  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (code.length === 6) {
      stepUpRequest.resolve(code);
      setCode('');
    }
  };
  const cancel = () => {
    stepUpRequest.reject(new Error('Confirmare anulată'));
    setCode('');
  };
  return (
    <Modal title="Confirmare suplimentară" onClose={cancel}>
      <form onSubmit={submit} className="stack">
        <p className="muted">
          Acțiunea cere un cod din aplicația de autentificare (valabil 5 minute, o singură
          utilizare).
        </p>
        <Field label="Cod TOTP" error={stepUpRequest.error} htmlFor="stepup-code">
          <Input
            id="stepup-code"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
            invalid={!!stepUpRequest.error}
            autoFocus
          />
        </Field>
        <div className="flex" style={{ justifyContent: 'flex-end' }}>
          <Button onClick={cancel}>Renunță</Button>
          <Button variant="primary" type="submit" disabled={code.length !== 6}>
            Confirmă
          </Button>
        </div>
      </form>
    </Modal>
  );
}
